/* tslint:disable */
/* eslint-disable */
export enum ReportFileTypeEnum {
  Unknown = 'Unknown',
  MarketReconciliationReport = 'MarketReconciliationReport',
  PayoutsReconciliationReport = 'PayoutsReconciliationReport',
  PartnerSettlementReport = 'PartnerSettlementReport'
}
